import { VictoryLabel, VictoryLabelProps } from 'victory';
import { fontStyle } from './cbsGraph.config';

export const Label = ({ ...props }: VictoryLabelProps) => (
	<VictoryLabel style={{ ...fontStyle }} {...props} />
);
